import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    icon: 'ri-link',
    title: '获取官方入口',
    description: '通过本页面获取禁漫天最新官方入口地址，确保安全访问',
    link: '/article/1',
  },
  {
    step: '02',
    icon: 'ri-user-add-line',
    title: '注册账号',
    description: '使用手机号或邮箱快速注册，三步完成账号创建',
    link: '/article/2',
  },
  {
    step: '03',
    icon: 'ri-search-line',
    title: '浏览分类',
    description: '按分类浏览海量漫画资源，精准找到你喜欢的作品',
    link: '/category/rexue-maoxian',
  },
  {
    step: '04',
    icon: 'ri-book-read-line',
    title: '畅享阅读',
    description: '使用阅读器畅快阅读，支持离线下载和个性化设置',
    link: '/article/4',
  },
];

export default function HowToUse() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            快速上手指南
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            只需四步，即可开启你的禁漫天漫画之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {steps.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="group relative bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Step number */}
              <span className="absolute top-4 right-4 text-4xl font-heading font-bold text-background-200 group-hover:text-primary-100 transition-colors duration-300">
                {item.step}
              </span>

              <div className="relative z-10">
                <div className="w-11 h-11 mb-4 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}